export default __webpack_public_path__ + "static/media/raw-material-catchment-icon.fa05b77b.svg";